import { Location } from '../../../../../../models/CommentHistory/Comment';
import { Location as ApiLocation } from '../../Models/ApiComment';

export function toLocation(location?: ApiLocation): Location | undefined {
  if (location === undefined) {
    return undefined;
  }

  return {
    ...location,
  };
}
